/* eslint-disable arrow-parens */
import { useEffect, useRef } from 'react';

const useAutoScroll = <T extends HTMLElement>(initialRef: T | null, list: any[], callback: () => void) => {
    const ref = useRef<T>(initialRef);


    useEffect(() => {
        if (ref.current) {
            ref.current.scrollTop = ref.current.scrollHeight;
        }

        if (list && list.length) {
            callback();
        }
    }, [list, ref]);

    return ref;
};

export default useAutoScroll;
